import { Component } from '@theme/component';

class IntentionQuiz extends Component {
    constructor() {
        super();

        this.initialLoadComplete = false;

        this.steps = [
        {
            id: 1,
            title: "Initial Focus",
            question: "What primary intention or goal are you currently focused on achieving?",
            options: [
                { text: "Connection & Purpose", value: "Connection & Purpose", description: "Deepening bonds with others and finding meaning in your life's path." },
                { text: "Courage & Action", value: "Courage & Action", description: "Seeking inner bravery to overcome fears and move forward decisively." },
                { text: "Focus & Clarity", value: "Focus & Clarity", description: "Eliminating mental fog to achieve clear decision-making and concentration." },
                { text: "Protection & Defence", value: "Protection & Defence", description: "Creating energetic boundaries and warding off negativity or challenging influences." },
                { text: "Strength & Endurance", value: "Strength & Endurance", description: "Building physical, mental, and emotional resilience for long-term effort." },
                { text: "Wealth & Prosperity", value: "Wealth & Prosperity", description: "Attracting abundance in all forms, including financial and material well-being." },
                { text: "Wellness & Health", value: "Wellness & Health", description: "Nurturing the physical body, promoting vitality, and restoring balance." },
            ],
            type: 'intention'
        },
        {
            id: 2,
            title: "Emotional Anchor",
            question: "What frequency or desired state do you want to anchor in your daily life?",
            options: [
                { text: "Serene and Balanced", value: "Serene", description: "A state of deep calm, emotional resilience, and quiet, effortless grace." },
                { text: "Powerful and Unstoppable", value: "Unstoppable", description: "Feeling motivated, driven, and capable of overcoming any obstacle." },
                { text: "Sharp and Decisive", value: "Decisive", description: "Having mental clarity, precision, and the ability to make choices quickly." },
                { text: "Grounded and Present", value: "Grounded", description: "Feeling secure, stable, and deeply connected to the present moment." },
            ],
            type: 'frequency'
        },
        {
            id: 3,
            title: "Product Expression",
            question: "Which expression best suits your style and daily lifestyle?",
            options: [
                { text: "Bracelet (Tactile reminder, easily visible)", value: "Bracelet", description: "Kept close on the wrist, perfect for grounding and constant visual reference." },
                { text: "Necklace (Close to the heart, subtle statement)", value: "Necklace", description: "Worn over the heart or throat chakra, ideal for emotional and expressive intentions." },
            ],
            type: 'product_type'
        },
        {
            id: 4,
            title: "Reveal Your Path",
            question: "Reveal Your Intention. Claim Your 10% Off.",
            type: 'email_capture'
        }
    ];

this.resultsMatrix = {
    "Connection & Purpose": {
        "Serene": {
            description: "Your path to <strong>Connection & Purpose</strong> is anchored in <strong>Serenity</strong>. You are meant to attract deep, meaningful relationships and manifest your calling through a peaceful, open presence. This calm state ensures you lead with authenticity, drawing in the right people and opportunities effortlessly."
        },
        "Unstoppable": {
            description: "Your intention of <strong>Connection & Purpose</strong> is best fueled by being <strong>Unstoppable</strong>. This combination is about fearlessly pursuing your highest calling and purpose with massive outreach. It generates the drive needed to share your mission with the world and connect with those who truly resonate."
        },
        "Decisive": {
            description: "To achieve <strong>Connection & Purpose</strong>, you need <strong>Decisiveness</strong>. This anchor empowers you to set clear, intentional boundaries and make strong choices regarding your path and relationships. It ensures your energy is directed only toward people and projects that align with your highest purpose."
        },
        "Grounded": {
            description: "The foundation for <strong>Connection & Purpose</strong> is the <strong>Grounded</strong> state. Find stability in your core self and connect deeply to the present moment. This anchor provides the inner security needed for authentic connection and fulfilling purpose, rooted in reality."
        }
    },
    "Courage & Action": {
        "Serene": {
            description: "To master <strong>Courage & Action</strong>, anchor <strong>Serenity</strong>. True bravery is not the absence of fear, but acting from a place of quiet confidence. This inner-peace is the <strong>foundation</strong> of your resilience, allowing you to move forward without panic or emotional drain."
        },
        "Unstoppable": {
            description: "Your intention of <strong>Courage & Action</strong> requires the full power of being <strong>Unstoppable</strong>. This pairing generates high-energy momentum, enabling you to overcome any challenge. Project this fearless drive and watch resistance dissolve as you move toward your goals."
        },
        "Decisive": {
            description: "A <strong>Decisive</strong> state is the sharp focus needed to conquer hesitation on your path to <strong>Courage & Action</strong>. It allows you to take immediate, effective steps. Eliminate doubt and procrastination by anchoring the clarity to make swift, impactful choices."
        },
        "Grounded": {
            description: "The core stability required for <strong>Courage & Action</strong> comes from being <strong>Grounded</strong>. This anchor provides the <strong>foundation</strong> that allows you to stand firm in the face of any challenge without wavering, ensuring your actions are stable and reliable."
        }
    },
    "Focus & Clarity": {
        "Serene": {
            description: "The deepest source of <strong>Focus & Clarity</strong> is <strong>Serenity</strong>. <strong>Tranquillity</strong> and inner peace eliminate mental clutter and distraction, allowing laser-like concentration to emerge. Anchor this calm to make your mind a clear, unwavering instrument."
        },
        "Unstoppable": {
            description: "Your desire for <strong>Focus & Clarity</strong> is magnified by being <strong>Unstoppable</strong>. This potent combination directs powerful, sustained energy toward a single point, ensuring your productivity is maximised and cannot be broken by interruption."
        },
        "Decisive": {
            description: "To truly master <strong>Focus & Clarity</strong>, anchor <strong>Decisiveness</strong>. This creates a synergistic boost where clarity of thought immediately translates into effective, swift action. You will eliminate mental bottlenecks and move from thought to execution instantly."
        },
        "Grounded": {
            description: "Achieve <strong>Focus & Clarity</strong> by using the <strong>Grounded</strong> state. This anchor clears mental fog by connecting your mind to your physical reality and core stability, eliminating anxiety-fueled thoughts and promoting sharp, practical thinking."
        }
    },
    "Protection & Defense": {
        "Serene": {
            description: "The highest form of <strong>Protection & Defense</strong> comes from <strong>Serenity</strong>. This anchor promotes non-reactive defense, allowing you to maintain inner peace and flow, deflecting negativity without emotional entanglement or stress."
        },
        "Unstoppable": {
            description: "For powerful <strong>Protection & Defense</strong>, anchor being <strong>Unstoppable</strong>. This combination helps you project an intimidating, powerful boundary. Your energy becomes a formidable shield that cannot be breached, warding off lower vibrations effectively."
        },
        "Decisive": {
            description: "To create strong <strong>Protection & Defense</strong>, you must anchor <strong>Decisiveness</strong>. This empowers you to rapidly identify and cut off negative influences, making quick, firm choices to protect your space, time, and energy instantly."
        },
        "Grounded": {
            description: "The most stable <strong>Protection & Defense</strong> is rooted in being <strong>Grounded</strong>. This anchor builds an immovable shield of energy that roots you deeply, making you resilient to outside forces and helping you feel physically untouchable."
        }
    },
    "Strength & Endurance": {
        "Serene": {
            description: "Your goal of <strong>Strength & Endurance</strong> is fueled by <strong>Serenity</strong>. This anchor promotes steady, unhurried progress. Your resilience is built on calmness, allowing for consistent long-term effort without burnout or emotional crashes."
        },
        "Unstoppable": {
            description: "To achieve peak <strong>Strength & Endurance</strong>, anchor being <strong>Unstoppable</strong>. This provides brute force energy, helping you overcome limits and push past physical or mental barriers with powerful, sustained vitality and drive."
        },
        "Decisive": {
            description: "Your goal of <strong>Strength & Endurance</strong> is best fueled by <strong>Decisiveness</strong>. True endurance is often undermined by doubt and hesitation. Decisiveness cuts through mental fatigue and focuses your will, transforming long-term effort into unwavering mastery. This alignment ensures every action contributes directly to your ultimate resilience."
        },
        "Grounded": {
            description: "The core of <strong>Strength & Endurance</strong> is being <strong>Grounded</strong>. This anchor provides root strength and deep, stable support. Your resilience is built from an unshakeable core, ensuring your energy is deeply sourced and lasting."
        }
    },
    "Wealth & Prosperity": {
        "Serene": {
            description: "Your manifestation of <strong>Wealth & Prosperity</strong> is amplified by <strong>Serenity</strong>. You will attract abundance through a calm, high-vibration state, manifesting from <strong>self-sufficiency</strong> and effortless flow rather than desperate pursuit."
        },
        "Unstoppable": {
            description: "To achieve <strong>Wealth & Prosperity</strong>, anchor being <strong>Unstoppable</strong>. This combination is ideal for aggressive goal pursuit and manifestation, projecting the confidence and momentum necessary to draw massive financial opportunity into your life."
        },
        "Decisive": {
            description: "A <strong>Decisive</strong> state is key to managing <strong>Wealth & Prosperity</strong>. It eliminates hesitation in investment and risk-taking, empowering you to make rapid, informed choices about opportunities and capture wealth before the moment passes."
        },
        "Grounded": {
            description: "The <strong>Grounded</strong> state is the anchor for establishing a solid, practical foundation for <strong>Wealth & Prosperity</strong>. This ensures your financial security is stable, your growth is sustained, and your material life is based on sound, realistic principles."
        }
    },
    "Wellness & Health": {
        "Serene": {
            description: "The path to <strong>Wellness & Health</strong> is paved with <strong>Serenity</strong>. This anchor is critical for reducing stress, promoting deep recovery, and allowing the body to heal itself through inner peace and emotional balance."
        },
        "Unstoppable": {
            description: "To boost your <strong>Wellness & Health</strong>, anchor being <strong>Unstoppable</strong>. This combination channels high vitality, pure physical energy, and vibrant life force into your being, driving a relentless pursuit of peak physical condition."
        },
        "Decisive": {
            description: "A <strong>Decisive</strong> state is essential for long-term <strong>Wellness & Health</strong>. It enables you to make strong, lasting commitments to healthy habits, eliminating self-sabotage and firmly choosing the actions that promote your well-being."
        },
        "Grounded": {
            description: "Achieve true <strong>Wellness & Health</strong> through being <strong>Grounded</strong>. This anchor focuses on root health, stability, and deep physical nourishment, connecting you with the body's natural balance for enduring vitality."
        }
    }
};
    }

    #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;

    this.#setDefaultState();

    this.quizContent = this.querySelector('#quizContent');
    this.prevBtn = this.querySelector('#prevBtn');
    this.progressBar = this.querySelector('#progressBar');
    this.stepTitle = this.querySelector('#stepTitle');

    this.prevBtn.addEventListener('click', (event) => this.#prevStep(event), { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller.abort();
  }

   #nextStep() {
        if (this.currentStep === this.selectionStepsCount) {
            if (this.isCustomerLoggedIn || this.isKlaviyoKnown) {
                this.currentStep = this.totalSteps;
                
                this.#renderResults(this.isCustomerLoggedIn ? this.customerEmail : null); 
            } else {
                this.currentStep++;
                this.#renderStep(this.currentStep);
            }
        } else if (this.currentStep < this.totalSteps) {
            this.currentStep++;
            this.#renderStep(this.currentStep);
        } 
    }

    #prevStep(event) {
    event.preventDefault();
        if (this.currentStep > 1) {
            this.currentStep--;
            if (this.currentStep === this.totalSteps && (this.isCustomerLoggedIn || this.isKlaviyoKnown)) {
                 this.currentStep = this.selectionStepsCount;
            }
            this.#renderStep(this.currentStep);
        }
    }

    #renderStep(stepIndex) {
        const step = this.steps[stepIndex - 1];
        if (!step || !this.quizContent) return;
        
        if (this.stepTitle) {
            this.stepTitle.textContent = step.title;
        }
        this.#updateProgressBar(stepIndex);

        this.quizContent.style.opacity = '0';

        setTimeout(() => {
            let html = '';

            if (step.type === 'email_capture') {
                html = `
                    <div class="email-form-container">
                        <h2 class="quiz-question">${step.question}</h2>
                        <p>Enter your email below to receive your <strong>personalised product path</strong> and a <strong>10% off code</strong> to begin your transformation.</p>
                        <div class="email-input-group">
                            <input 
                                type="email" 
                                id="emailInput" 
                                class="email-input" 
                                placeholder="Your email address"
                                autocomplete="email"
                                required
                                aria-label="Email address for personalised path and discount code"
                            >
                            <p id="emailError" class="error-message"></p>
                            <button 
                                class="size-style button-tertiary email-submit-button"
                                id="submitEmailBtn"
                            >
                                Reveal My Path
                            </button>
                        </div>
                        <p style="margin-top: 15px; font-size: 0.8rem; text-align: center;">
                            By clicking 'Reveal My Path', you agree to receive marketing emails from Mana on Men.
                        </p>
                    </div>
                `;
            } else {
            html = `<h3 class="quiz-question">${step.question}</h3><div class="options-group" data-type="${step.type}">`;
            
            const selectedValue = this.selections[step.type];
            step.options.forEach(option => {
                const isSelected = selectedValue === option.value;
                const selectedClass = isSelected ? 'selected' : '';
                const ariaPressed = isSelected ? 'true' : 'false';
                const descriptionHtml = option.description ? `<span class="option-description">${option.description}</span>` : '';

                html += `
                    <button 
                        class="option-button ${selectedClass}" 
                        data-type="${step.type}" 
                        data-value="${option.value}"
                        role="button"
                        aria-pressed="${ariaPressed}"
                        aria-describedby="option-title"
                    >
                        <div class="option-text-group">
                            <span class="option-title">${option.text}</span>
                            ${descriptionHtml}
                        </div>
                    </button>
                `;
            });
            
            html += `</div>`;
        }

            this.quizContent.innerHTML = html;
            
            if (step.type === 'email_capture') {
                this.quizContent.querySelector('#submitEmailBtn')?.addEventListener('click', () => this.#submitEmail());
            } else {
                this.#attachStepListeners(step.type);
            }

            this.quizContent.style.opacity = '1';

            if (this.initialLoadComplete) { 
                this.#scrollToTop();
            } else {
                this.initialLoadComplete = true;
            }

        }, 250);
    }

#renderResults(emailCollected = null) {
        const selections = this.selections;
        
        const recommendedCollection = selections['intention'] || 'Connection & Purpose';
        const emotionalFrequency = selections['frequency'] || 'Serene';
        const rawProductType = selections['product_type'] || 'Bracelet';

        let productFilterValue = '';
        if (rawProductType.includes('Bracelet')) {
            productFilterValue = 'Bracelets';
        } else if (rawProductType.includes('Necklace')) {
            productFilterValue = 'Necklaces';
        }
        const productFilter = `?filter.p.product_type=${productFilterValue}`;

        const generateSlug = (text) => {
            return text.toLowerCase()
                       .replace(/ & /g, '-') 
                       .replace(/ /g, '-')
                       .replace(/[^\w-]+/g, ''); 
        };
        const collectionSlug = generateSlug(recommendedCollection);
        const collectionLink = `/collections/${collectionSlug}${productFilter}`;

        const recommendation = this.resultsMatrix[recommendedCollection]?.[emotionalFrequency] || {
            description: `We found a strong match for your intention of <strong>${recommendedCollection}</strong> and the core state of <strong>${emotionalFrequency}</strong>. This potent combination is guaranteed to guide your path.`
        };

        this.#trackGA4Event('quiz_complete', {
            quiz_name: 'Path_Finder_Quiz',
            final_intention: recommendedCollection,
            final_core_state: emotionalFrequency,
            recommended_product: rawProductType,
            recommended_collection_slug: collectionSlug
        });

        this.#subscribeToKlaviyo(
          emailCollected || this.customerEmail || '',
            recommendedCollection,
            emotionalFrequency,
            rawProductType
            );
        
        if (this.quizContent) {
            this.quizContent.style.opacity = '0';
        }

        setTimeout(() => {
            const html = `
                <div class="result-center">
                    <h3 class="result-title">Your Personalised Recommendation</h3>
                    <p class="result-description">
                        ${recommendation.description}
                    </p>
                    
                    <div class="result-box">
                        <p>Your Intention Focus:</p>
                        <p class="result-collection-name">${recommendedCollection}</p>
                    </div>

                    <p class="result-meta">
                       We recognise that true intention should be held close. Therefore, we recommend you explore the <strong>${recommendedCollection} Collection</strong> in the form of a <strong>${rawProductType}</strong>. This specific expression is ideal for providing a constant, tactile, and energetic reminder of your personalised frequency throughout your daily life.
                    </p>

                    <a href="${collectionLink}" class="size-style button-tertiary result-link-button">
                        View The ${recommendedCollection} Collection
                    </a>
                </div>
            `;

            if (this.quizContent) {
                this.quizContent.innerHTML = html;
            }
            
            this.prevBtn?.classList.add('hidden');
            
            if (this.stepTitle) {
                this.stepTitle.textContent = 'Recommendation Complete';
            }
            if (this.progressBar) {
                this.progressBar.style.width = '100%';
            }
            
            if (this.quizContent) {
                this.quizContent.style.opacity = '1';

                this.#scrollToTop(); 
            }
        }, 250);
    }

    #updateProgressBar(stepIndex) {
        const step = this.steps[stepIndex - 1];
        if (!step) return;

        if (this.stepTitle) {
        if (step.type === 'email_capture') {
                this.stepTitle.textContent = step.title;
            } else {
                this.stepTitle.textContent = `Step ${Math.min(stepIndex, this.selectionStepsCount)} of ${this.selectionStepsCount}: ${step.title}`;
            }
        }
        
        if (this.progressBar) {
            const currentSelectionStep = Math.min(stepIndex, this.selectionStepsCount);
            const progress = (currentSelectionStep / this.selectionStepsCount) * 100;
            this.progressBar.style.width = `${progress}%`;
        }
        
        if (this.prevBtn) {
            this.prevBtn.disabled = stepIndex === 1;
        }
    }
    
    #attachStepListeners(type) {
        const { signal } = this.#controller;
        
        const newOptionBtns = this.quizContent.querySelectorAll(`.option-button[data-type="${type}"]`);
        
        newOptionBtns.forEach(btn => {
            btn.addEventListener('click', (event) => this.#selectOption(event), { signal });
        });
    }

    #scrollToTop() {
        if (!this.isConnected) return; 

        const bodyStyles = window.getComputedStyle(document.body);
        
        let headerHeight = bodyStyles.getPropertyValue('--header-height').trim();

        headerHeight = parseFloat(headerHeight) || 0;
        
        const rect = this.getBoundingClientRect();
        
        const elementTopInDocument = rect.top + window.scrollY;
        
        const targetScrollPosition = elementTopInDocument - headerHeight;

        if (rect.top < headerHeight || rect.top > window.innerHeight) {
            window.scrollTo({
                top: targetScrollPosition,
                behavior: 'smooth'
            });
        }
    }

    #selectOption(event) {
        event.preventDefault();

        const button = event.currentTarget;
  const type = button?.dataset?.type;
  const value = button?.dataset?.value;

  if (!button || !type || !value) {
    return;
  }

  this.selections[type] = value;

  const siblingBtns = this.quizContent?.querySelectorAll(`.option-button[data-type="${type}"]`) || [];

  siblingBtns.forEach(btn => {
const isSelected = btn === button;
                        
            if (isSelected) {
                btn.classList.add('selected');
            } else {
                btn.classList.remove('selected');
            }
    })

    this.#trackGA4Event('quiz_step_complete', {
            quiz_name: 'Path_Finder_Quiz',
            step_number: this.currentStep,
            step_title: this.steps[this.currentStep - 1].title,
            selection_type: type,
            selection_value: value
        });

        this.#nextStep();
    }

    #setDefaultState() {
    this.currentStep = 1;
    this.totalSteps = this.steps.length;
    this.selectionStepsCount = 3;
    this.selections = {};

    this.isCustomerLoggedIn = this.querySelector('#isCustomerLoggedIn')?.value?.length > 0;
    this.customerEmail = this.querySelector('#customerEmail')?.value || '';

    this.isKlaviyoKnown = false;
    this.klaviyoCheckAttempts = 0;
    this.maxKlaviyoAttempts = 20;
    this.#checkKlaviyoIdentification();

    this.#trackGA4Event('quiz_start', {
            quiz_name: 'Path_Finder_Quiz',
            total_steps: this.selectionStepsCount
        });
  }

  #trackGA4Event(eventName, params) {
        if (typeof gtag === 'function') {
            gtag('event', eventName, params);
        }
    }

    #checkKlaviyoIdentification() {
        if (typeof klaviyo !== 'undefined' && typeof klaviyo.isIdentified === 'function') {
            klaviyo.isIdentified().then(isIdentifiedResult => {
                this.isKlaviyoKnown = isIdentifiedResult;
                this.#renderStep(this.currentStep);
            }).catch(() => {
                this.isKlaviyoKnown = false; 
                this.#renderStep(this.currentStep);
            });
        } else if (this.klaviyoCheckAttempts < this.maxKlaviyoAttempts) {
            this.klaviyoCheckAttempts++;
            setTimeout(() => this.#checkKlaviyoIdentification(), 100);
        } else {
            this.isKlaviyoKnown = false;
            this.#renderStep(this.currentStep);
        }
    }

    #subscribeToKlaviyo(email, intention, frequency, productType) {
        if (typeof klaviyo !== 'undefined') {
            klaviyo.push(['identify', {
                '$email': email,
                'Quiz Intention': intention,
                'Quiz Core State': frequency,
                'Quiz Recommended Product': productType,
                'Source': 'Path Finder Quiz'
            }]);
            
            klaviyo.push(['track', 'Quiz Completed', {
                'Intention': intention,
                'Core State': frequency,
                'Recommended Product': productType,
                'Source': 'Path Finder Quiz'
            }]);
        }
    }

    #isValidEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }

    #submitEmail() {
        const emailInput = this.querySelector('#emailInput');
        const errorElement = this.querySelector('#emailError');
        const email = emailInput.value.trim();

        if (!this.#isValidEmail(email)) {
            errorElement.textContent = 'Please enter a valid email address.';
            emailInput.focus();
            return;
        }

        errorElement.textContent = '';
        
        this.currentStep++;
        this.#renderResults(email);
    }
}

if (!customElements.get('intention-quiz')) {
  customElements.define('intention-quiz', IntentionQuiz);
}